/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";
import PropTypes from "prop-types";
import useTranslate from "~hooks/useTranslate/useTranslate";
import Link from '~hooks/link';
import styles from './searchVariable.module.scss'
import Card from "../../../atoms/cards/default-card";

const VariableComponent = ({
  recommendedCasinos,
  topSearches,
  showRecommendedCasinos,
  showTopSearches,
  extraClass,
  RecommendedItem,
  showAutoComplete,
  autocompleteEnabled,
  filteredData,
}) => {
  const ComponentToRender = RecommendedItem || Card;
  return (
    <div
      className={`${styles.searchVariableComponent} ${
        showAutoComplete && autocompleteEnabled && filteredData
          ? styles.searchVariableWithAutocomplete
          : ""
      }`}
    >
      {showTopSearches && (
        <div className={styles.topSearches}>
          <p>Top Searches:</p>
          {topSearches?.map((item) => (
            <Link key={item.id} to={item?.link?.value}>
              {item?.label}
            </Link>
          ))}
        </div>
      )}
      {showRecommendedCasinos && (
        <div className={styles.recommendedCasinos || ""}>
          <p className={styles.recommendedCasinosHeader}>
            {useTranslate("recommendedCasinosHeader", "Recommended Casinos")}
          </p>
          <div
            className={`${styles.recommendedCasinosItems || ""} ${
              extraClass || ""
            }`}
          >
            {recommendedCasinos?.map((item) => (
              <ComponentToRender item={{ relation: item }} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

VariableComponent.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  recommendedCasinos: PropTypes.array.isRequired,
  showRecommendedCasinos: PropTypes.bool,
  showTopSearches: PropTypes.bool,
  showAutoComplete: PropTypes.bool,
  autocompleteEnabled: PropTypes.bool,
  topSearches: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
    })
  ).isRequired,
  extraClass: PropTypes.string,
  RecommendedItem: PropTypes.elementType.isRequired,
  filteredData: PropTypes.shape({})
};

export default VariableComponent;
